import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, MailIcon, ClockIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { FOOTER, NAV, PRACTICE, CONTACT, BRAND_TAGLINE } from '../../content/site';
export function Footer() {
  const {
    language
  } = useLanguage();
  const t = FOOTER[language];
  const nav = NAV[language];
  const c = CONTACT[language];
  const legalLinks = [{
    to: '/privacy',
    label: t.links.privacy
  }, {
    to: '/terms',
    label: t.links.terms
  }, {
    to: '/disclaimer',
    label: t.links.disclaimer
  }, {
    to: '/accessibility',
    label: t.links.accessibility
  }];
  return <footer className="relative overflow-hidden bg-espresso px-5 pb-10 pt-20 text-pearl sm:px-8 lg:px-10" data-id="element-102" data-mp="3n17rvt7uuddc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-grain opacity-60" data-id="element-103" data-mp="3e2w562a3zzq6" />
      <div className="relative z-10 mx-auto w-full max-w-6xl" data-id="element-104" data-mp="3939kx8vv5j7v">
        <div className="grid gap-12 border-b border-pearl/10 pb-14 md:grid-cols-2 lg:grid-cols-4" data-id="element-105" data-mp="3965hass2bzu7">
          <div data-id="element-106" data-mp="2kb9yx6zfta40">
            <Link to="/" aria-label={PRACTICE.nameTitle} className="inline-flex flex-col leading-none" data-id="element-107" data-mp="2p3l1khlkba09">
              <span className="font-serif text-lg font-normal tracking-[0.18em] text-pearl" data-id="element-108" data-mp="2be9fler8627f">
                {PRACTICE.name}
              </span>
              <span className="mt-1.5 text-[9px] font-semibold uppercase tracking-[0.24em] text-bronze" data-id="element-109" data-mp="340kgkqiqu54r">
                {BRAND_TAGLINE[language]}
              </span>
            </Link>
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-pearl/55" data-id="element-110" data-mp="2u2whjoe3ubgs">
              {t.legal}
            </p>
          </div>

          <div data-id="element-111" data-mp="2z0pmyf7l31g0">
            <h2 className="mb-5 text-[10px] font-semibold uppercase tracking-[0.22em] text-pearl/45" data-id="element-112" data-mp="2z067r69bir5o">
              {t.contact}
            </h2>
            <ul className="space-y-4 text-sm font-light text-pearl/70" data-id="element-113" data-mp="1nndh5ys9k8r7">
              <li className="flex items-start gap-3" data-id="element-114" data-mp="1nkhkeds5jq4c">
                <MapPinIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-bronze" strokeWidth={1.5} data-id="element-115" data-mp="13jfycvqx2rv4" />
                <address className="not-italic leading-relaxed" data-id="element-116" data-mp="usfpcci68aoq">
                  {PRACTICE.addressLines.map(line => <span key={line} className="block" data-id="element-117" data-mp="ptuku0vvz4uh">
                      {line}
                    </span>)}
                </address>
              </li>
              <li className="flex items-start gap-3" data-id="element-118" data-mp="fv55ofvdjyhx">
                <MailIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-bronze" strokeWidth={1.5} data-id="element-119" data-mp="ftln2im8xbcz" />
                <a href={`mailto:${PRACTICE.email}`} className="break-all transition-colors hover:text-pearl" data-id="element-120" data-mp="6uqfp37gtv83">
                  {PRACTICE.email}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-121" data-mp="216ey5fcwofx8">
            <h2 className="mb-5 text-[10px] font-semibold uppercase tracking-[0.22em] text-pearl/45" data-id="element-122" data-mp="28s0nxhbiugx8">
              {t.hours}
            </h2>
            <ul className="space-y-4 text-sm font-light text-pearl/70" data-id="element-123" data-mp="2dq27s4gruk9r">
              <li className="flex items-start gap-3" data-id="element-124" data-mp="2ii29o2gejn8z">
                <ClockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-bronze" strokeWidth={1.5} data-id="element-125" data-mp="2iilubqxfspqp" />
                <span data-id="element-126" data-mp="1ptob9lleioww">{t.hoursValue}</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-127" data-mp="1pv95fa3t05u8">
                <GlobeIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-bronze" strokeWidth={1.5} data-id="element-128" data-mp="1utap9x92096r" />
                <span data-id="element-129" data-mp="1ztp01n21hx8h">{c.languages}</span>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:grid-cols-1" data-id="element-130" data-mp="23qtihowupttq">
            <div data-id="element-131" data-mp="3b5pthf9um9uk">
              <h2 className="mb-5 text-[10px] font-semibold uppercase tracking-[0.22em] text-pearl/45" data-id="element-132" data-mp="3b68095u506gq">
                {t.navigate}
              </h2>
              <ul className="space-y-3" data-id="element-133" data-mp="3dq49xdqob3ls">
                {nav.links.map(link => <li key={link.to} data-id="element-134" data-mp="38s2ur3wdbofl">
                    <Link to={link.to} className="text-sm font-light text-pearl/70 transition-colors hover:text-pearl" data-id="element-135" data-mp="38t4d7tfprd7c">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-136" data-mp="iayxlz1jrfj">
              <h2 className="mb-5 text-[10px] font-semibold uppercase tracking-[0.22em] text-pearl/45" data-id="element-137" data-mp="3rqotic4ex3gc">
                {t.legalLinks}
              </h2>
              <ul className="space-y-3" data-id="element-138" data-mp="a8vwd62zapwv">
                {legalLinks.map(link => <li key={link.to} data-id="element-139" data-mp="5c5h2kyzzyci">
                    <Link to={link.to} className="text-sm font-light text-pearl/70 transition-colors hover:text-pearl" data-id="element-140" data-mp="5d73fllgs79j">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-b border-pearl/10 py-10" data-id="element-141" data-mp="12wxa9ewqswn1">
          <p className="mx-auto max-w-3xl text-center text-[11px] font-light leading-relaxed text-pearl/40" data-id="element-142" data-mp="12uazz7igw314">
            {t.disclaimer}
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 pt-8 sm:flex-row sm:justify-between" data-id="element-143" data-mp="tuo22voy5fct">
          <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-pearl/35" data-id="element-144" data-mp="f6b27nmqncd1">
            {t.copyright}
          </p>
          <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-pearl/35" data-id="element-145" data-mp="jzvxv90uzu92">
            {PRACTICE.address}
          </p>
        </div>
      </div>
    </footer>;
}